import { render, staticRenderFns } from "./addReportTask.vue?vue&type=template&id=0cff0234&"
import script from "./addReportTask.vue?vue&type=script&lang=js&"
export * from "./addReportTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports